"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gmailCreateDraft = exports.gmailCreateDraftResultSchema = exports.gmailCreateDraftArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument input schema for draft fields
exports.gmailCreateDraftArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('create-draft', zod_1.z.object({
    to: zod_1.z.string().describe("The recipient's email address"),
    subject: zod_1.z.string().describe('The email subject line'),
    body: zod_1.z.string().describe('The email body content'),
    cc: zod_1.z.string().nullish().describe("Optional CC recipient's email address"),
    bcc: zod_1.z.string().nullish().describe("Optional BCC recipient's email address"),
    fromName: zod_1.z
        .string()
        .nullish()
        .describe('Optional sender name (defaults to authenticated user)'),
    fromEmail: zod_1.z.string().nullish().describe('Optional sender email address'),
    replyTo: zod_1.z.string().nullish().describe('Optional reply-to email address'),
    bodyType: zod_1.z
        .enum(['plaintext', 'html'])
        .nullish()
        .describe('Optional body type ("plaintext" or "html")'),
    attachmentFilenames: zod_1.z
        .array(zod_1.z.string())
        .nullish()
        .describe('Optional array of attachment filenames. Must match the length of the attachmentUrlOrPaths array.'),
    attachmentUrlsOrPaths: zod_1.z
        .array(zod_1.z.string())
        .nullish()
        .describe('Optional array of attachment URLs or file paths. Must match the length of the attachmentFilenames array.'),
    inReplyTo: zod_1.z.string().nullish().describe('Optional message ID this email is replying to'),
    mimeType: zod_1.z.string().nullish().describe('Optional MIME type for the message'),
}));
// Message schema (used in result)
var gmailMessageSchema = zod_1.z.object({
    id: zod_1.z.string().describe('The immutable ID of this message (e.g, "17f4ac8b4a1b2c3d")'),
    threadId: zod_1.z
        .string()
        .describe('The ID of the thread the message belongs to (e.g, "17f4ac8b4a1b2c3d")'),
    labelIds: zod_1.z
        .array(zod_1.z.string())
        .describe('List of label IDs applied to this message (e.g, ["INBOX", "UNREAD"])'),
    snippet: zod_1.z
        .string()
        .nullish()
        .describe('required: A short part of the message text (e.g, "Hello, this is a test message...")'),
});
// Result schema
exports.gmailCreateDraftResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.object({
    id: zod_1.z.string().describe('The immutable ID of the draft (e.g., "r123456789")'),
    message: gmailMessageSchema.describe('The message content of the draft'),
}));
// Tool definition
exports.gmailCreateDraft = (0, common_1.createEmitModeToolMetadata)({
    id: 'gmailCreateDraft',
    displayName: 'Gmail Create Draft',
    displayDescription: 'Allows you to create a new draft message in Gmail',
    category: 'communication',
    color: common_1.BRAND_COLORS.GMAIL,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GMAIL),
    icon: 'gmail',
    argsSchema: exports.gmailCreateDraftArgsSchema,
}, exports.gmailCreateDraftResultSchema);
